<template>
  <FlyInputLabel
    :error="error || errorMessage"
    :label="label"
    class="fly-file-input"
  >
    <input
      ref="input"
      type="file"
      :style="{
        visibility: 'hidden',
        position: 'absolute',
        width: 0,
        height: 0,
      }"
      :accept="accept"
      @change="onFileInputChange"
    />
    <div>
      <FlyButtonRaw
        class="fly-button fly-button--secondary fly-button--icon"
        :class="{ 'fly-button--error': error || errorMessage }"
        icon-placement="left"
        icon="Plus"
        type="button"
        @click="onButtonClick"
      >
        <slot>{{ _buttonText }}</slot>
      </FlyButtonRaw>
    </div>
  </FlyInputLabel>
</template>

<script>
import VueTypes from 'vue-types';
import { get } from 'lodash';
import FlyInputLabel from 'shared/components/Form/FlyInputLabel.vue';
import FlyButtonRaw from 'shared/components/Button/FlyButton.vue';

export default {
  name: 'FlyPrivateKeyFileInput',
  components: {
    FlyButtonRaw,
    FlyInputLabel,
  },
  props: {
    buttonText: VueTypes.string.isRequired,
    error: VueTypes.string.def(''),
    label: VueTypes.string.def(''),
    accept: VueTypes.string.def(''),
  },
  emits: ['change', 'error'],
  data() {
    return {
      fileName: '',
      errorMessage: '',
    };
  },
  computed: {
    _buttonText() {
      return this.fileName || this.buttonText;
    },
  },
  methods: {
    onButtonClick() {
      this.$refs.input.click();
    },
    onFileInputChange(e) {
      this.errorMessage = '';
      const file = e.target.files[0];
      if (!file) return;
      this.fileName = get(file, 'name', '');
      return new Promise((resolve, reject) => {
        const fileRead = new FileReader();
        fileRead.addEventListener('load', (e) => {
          const content = e.target.result;
          if (this.validatePrivateKey(content)) {
            this.$emit('change', content);
            resolve(content);
          } else {
            this.errorMessage = 'Invalid PEM format';
            reject('Invalid PEM format');
          }
        });
        fileRead.readAsText(file);
      });
    },
    validatePrivateKey(content) {
      const contentStr = content.toString().trim();

      // Check for PEM format: -----BEGIN label----- and -----END label-----
      const beginMatch = contentStr.match(/^-----BEGIN ([^-]+)-----/);
      const endMatch = contentStr.match(/-----END ([^-]+)-----$/);

      if (!beginMatch || !endMatch) {
        this.$emit('error', 'Invalid PEM format');
        return false;
      }

      // Ensure the labels in header and footer match
      if (beginMatch[1] !== endMatch[1]) {
        this.$emit('error', 'Mismatched header and footer labels');
        return false;
      }

      return true;
    },
  },
  inheritAttrs: false,
};
</script>

<style lang="scss">
.fly-file-input.fly-label {
  margin-top: 0px;
  width: 42%;
}
</style>
